import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { GoChevronRight } from "react-icons/go";

function Chevron(props) {
  return (
    <GoChevronRight
      className={props.className}
      height={props.height}
      width={props.width}

    />
  );
}

/**
 * Accordion component.
 * It accepts 2 props:
 *  - titleContent
 *  - content
 * @param {*} props
 */
function Accordion(props) {
  const [setActive, setActiveState] = useState("");
  const [setHeight, setHeightState] = useState("0");
  const [setRotate, setRotateState] = useState("accordion__icon");

  const content = useRef(null);

  function toggleAccordion() {
    if (!props.content)
      return;

    setActiveState(setActive === "" ? "accordion-active" : "");
    setHeightState(
      setActive === "accordion-active" ? "0" : `${content.current.scrollHeight}px`
    );
    setRotateState(
      setActive === "accordion-active" ? "accordion__icon" : "accordion__icon rotate"
    );
  }

  const accordionHeight  =  { 
    maxHeight: `${setHeight}`
  }
  return (
    <div className="d-flex flex-column">
      <div className={`accordion ${setActive} ${props.content? 'cursor-pointer' : ''}`} onClick={toggleAccordion}>
        {/* only shows the chevron if there is content */}
        <div className="chevron">
          {props.content &&
            <Chevron className={`${setRotate}`} width={10} fill={"#777"} />
          }
        </div>
        {props.titleContent}
      </div>
      <div
        ref={content}
        style={accordionHeight}
        className="accordion__content"
      >
        {props.content}
      </div>
    </div>
  );
}

Accordion.propTypes = {
  titleContent: PropTypes.any.isRequired,
}
export default Accordion;
